import React, { useRef } from 'react';
import styled from 'styled-components';
import ProductItem from '../ProductItem';

const ProductCarousel = ({ title, products, subtitle }) => {
  const scrollRef = useRef(null);

  if (!products || products.length === 0) return null;

  const handleScroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === 'left' ? -300 : 300;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <SectionWrapper>
      <HeaderRow>
        <HeaderGroup>
          <SectionTitle>{title}</SectionTitle>
          {subtitle && <SectionSubtitle>{subtitle}</SectionSubtitle>}
        </HeaderGroup>
        <NavButtons>
          <NavBtn onClick={() => handleScroll('left')} aria-label="Previous products">
            ❮
          </NavBtn>
          <NavBtn onClick={() => handleScroll('right')} aria-label="Next products">
            ❯
          </NavBtn>
        </NavButtons>
      </HeaderRow>

      <ScrollTrack ref={scrollRef}>
        {products.map((product) => (
          <ItemCardWrap key={product.id}>
            <ProductItem product={product} />
          </ItemCardWrap>
        ))}
      </ScrollTrack>
    </SectionWrapper>
  );
};

export default ProductCarousel;

/* ---------- Styles ---------- */
const SectionWrapper = styled.div`
  margin: 40px 0;
  width: 100%;
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 20px;
`;

const HeaderGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const SectionTitle = styled.h2`
  font-size: 1.4rem;
  font-weight: 800;
  color: #1f2d3d;
  margin: 0;

  @media screen and (min-width: 768px) {
    font-size: 1.6rem;
  }
`;

const SectionSubtitle = styled.p`
  font-size: 0.88rem;
  color: #8a99a8;
  margin: 0;
  font-weight: 500;
`;

const NavButtons = styled.div`
  display: flex;
  gap: 8px;
`;

const NavBtn = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid rgba(31, 45, 61, 0.15);
  background: #fff;
  color: #24313f;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  display: grid;
  place-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.15s ease;

  &:hover {
    background: #01bf71;
    color: #fff;
    border-color: #01bf71;
    box-shadow: 0 4px 12px rgba(1, 191, 113, 0.3);
  }
`;

const ScrollTrack = styled.div`
  display: flex;
  gap: 16px;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 8px 4px 20px 4px;
  -webkit-overflow-scrolling: touch;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

const ItemCardWrap = styled.div`
  flex: 0 0 220px;
  max-width: 240px;

  @media screen and (min-width: 768px) {
    flex: 0 0 240px;
  }
`;
